import React from 'react';
import { useSlider } from '@hooks';

interface HeroSlide {
  id: number;
  image: string;
  subtitle: string;
  title: string;
  description: string;
}

const heroSlides: HeroSlide[] = [
  {
    id: 1,
    image: '/assets/images/hero-slider-1.jpg',
    subtitle: 'Best Iron-Stew Pot in Los Angeles',
    title: 'Authentic Northeastern\nChinese Cuisine 626 Area',
    description:
      'Experience the finest iron-stew pot dishes in Hacienda Heights. Traditional northeastern Chinese flavors await you.',
  },
  {
    id: 2,
    image: '/assets/images/hero-slider-2.jpg',
    subtitle: 'Best Northeastern Dish in 626 Area',
    title: 'Traditional Iron-Pot\nStews & More',
    description:
      "Discover why we're known for the best iron-stew pot dishes in Los Angeles. Authentic flavors, fresh ingredients.",
  },
  {
    id: 3,
    image: '/assets/images/hero-slider-3.jpg',
    subtitle: 'Hacienda Heights Chinese Restaurant',
    title: 'Premium Iron-Stew Pot\nExperience in LA',
    description:
      'Join us for the most authentic northeastern Chinese cuisine in the 626 area. Book your table today.',
  },
];

const HeroSection: React.FC = () => {
  const { currentIndex, next, prev, stopAutoplay, startAutoplay } = useSlider(heroSlides);

  return (
    <section className="hero text-center" aria-label="home" id="home">
      <ul className="hero-slider" data-hero-slider>
        {heroSlides.map((slide, index) => (
          <li
            key={slide.id}
            className={`slider-item ${index === currentIndex ? 'active' : ''}`}
            data-hero-slider-item
          >
            <div className="slider-bg">
              <img
                src={slide.image}
                width="1880"
                height="950"
                alt=""
                className="img-cover"
              />
            </div>

            <p className="label-2 section-subtitle slider-reveal">{slide.subtitle}</p>

            <h1 className="display-1 hero-title slider-reveal">
              {slide.title.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i < slide.title.split('\n').length - 1 && <br />}
                </React.Fragment>
              ))}
            </h1>

            <p className="body-2 hero-text slider-reveal">{slide.description}</p>

            <a
              href="https://happy-valley-village.res-menu.com/menu"
              className="btn btn-primary slider-reveal"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="text text-1">View Our Menu</span>
              <span className="text text-2" aria-hidden="true">
                View Our Menu
              </span>
            </a>
          </li>
        ))}
      </ul>

      <button
        className="slider-btn prev"
        aria-label="slide to previous"
        onClick={prev}
        onMouseOver={stopAutoplay}
        onMouseOut={startAutoplay}
        data-prev-btn
      >
        <ion-icon name="chevron-back"></ion-icon>
      </button>

      <button
        className="slider-btn next"
        aria-label="slide to next"
        onClick={next}
        onMouseOver={stopAutoplay}
        onMouseOut={startAutoplay}
        data-next-btn
      >
        <ion-icon name="chevron-forward"></ion-icon>
      </button>

      <a href="#" className="hero-btn has-after">
        <img
          src="/assets/images/hero-icon.png"
          width="48"
          height="48"
          alt="booking icon"
        />
        <span className="label-2 text-center span">Book A Table</span>
      </a>
    </section>
  );
};

export default HeroSection;
